import { apiClient } from "@/api";

export const TransportApi = {
  /**
   * Получение списка транспортных средств с пагинацией
   * @param {Object} params - Параметры запроса (пагинация и т.д.)
   * @returns {Promise<Object>}
   */
  async fetchTransports(params = {}) {
    return apiClient.get("/transports", { params });
  },

  /**
   * Получение информации о конкретном транспортном средстве
   * @param {Number|String} id - Идентификатор транспортного средства
   * @returns {Promise<Object>}
   */
  async fetchTransportById(id) {
    return apiClient.get(`/transports/${id}`);
  },

  /**
   * Свободная ёмкость отсеков ТС на дату доставки
   * @param {Number|String} id - Идентификатор транспортного средства
   * @param {Object} params - { delivery_date: 'YYYY-MM-DD', exclude_application_id }
   * @returns {Promise<Object>} { data: [{ id, number, capacity, planned_volume, free_volume, occupied_by: [] }] }
   */
  async getCompartmentsAvailability(id, params = {}) {
    return apiClient.get(`/transports/${id}/compartments-availability`, { params });
  },

  /**
   * Получение списка состояний транспортных средств
   * @returns {Promise<Object>}
   */
  async fetchTransportConditions(params = {}) {
    return apiClient.get("/transport-conditions", {
      params,
    });
  },

  /**
   * Получение списка статусов транспортных средств
   * @returns {Promise<Object>}
   */
  async fetchTransportStatuses(params = {}) {
    return apiClient.get("/transport-statuses", {
      params,
    });
  },

  /**
   * Получение списка типов транспортных средств
   * @returns {Promise<Object>}
   */
  async fetchTransportTypes(params = {}) {
    return apiClient.get("/transport-types", {
      params,
    });
  },

  /**
   * Получение списка транспортных операций для конкретного транспорта
   * @param {Number|String} transportId - Идентификатор транспортного средства
   * @param {Object} params - Параметры запроса (пагинация, фильтры и т.д.)
   * @returns {Promise<Object>}
   */
  async fetchTransportOperations(transportId, params = {}) {
    return apiClient.get("/transport-operations", {
      params: { transport_id: transportId, ...params },
    });
  },

  /**
   * Создание нового транспортного средства
   * @param {Object} transportData - Данные транспортного средства
   * @returns {Promise<Object>}
   */
  async createTransport(transportData) {
    return apiClient.post("/transports", transportData);
  },

  /**
   * Редактирование транспортного средства
   * @param {Number|String} id - Идентификатор транспортного средства
   * @param {Object} transportData - Данные транспортного средства
   * @returns {Promise<Object>}
   */
  async updateTransport(id, transportData) {
    return apiClient.put(`/transports/${id}`, transportData);
  },

  /**
   * Удаление транспортного средства
   * @param {Number|String} id - Идентификатор транспортного средства
   * @returns {Promise<Object>}
   */
  async deleteTransport(id) {
    return apiClient.delete(`/transports/${id}`);
  },
};
